import { Component, OnInit } from '@angular/core';
import { UtilsService } from '../../services/utils.service';
import { MENUITEMS } from 'src/app/data/_MENUITEMS';
import { MenuItem } from 'src/app/models/menu-item';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {
  _MENUITEMS: MenuItem[] = MENUITEMS;

  // tslint:disable-next-line:variable-name
  constructor(public _ui: UtilsService) { }

  ngOnInit() {
  }

}
